import { ApiResponse, customFetch } from './CustomFetch';
import { ModuleViewModel, ModuleIndex, ModuleStatus } from '../model/Module';


export const getModules = (): Promise<ModuleIndex[]> => {
  return customFetch('Module')
    .then((response) => response.json() as Promise<ApiResponse<ModuleIndex[]>>)
    .then((apiResponse) => apiResponse.data);
};

export const getAllPublishedModules = (): Promise<ModuleIndex[]> => {
  return customFetch('Module/published')
    .then((response) => response.json() as Promise<ApiResponse<ModuleIndex[]>>)
    .then((apiResponse) => apiResponse.data);
};

export const getModule = (moduleId: string): Promise<ModuleViewModel> => {
  return customFetch(`Module/${moduleId}`)
    .then((response) => response.json() as Promise<ApiResponse<ModuleViewModel>>)
    .then((apiResponse) => apiResponse.data);
};

export const createModule = (Module: ModuleViewModel): Promise<ApiResponse<string>> => {
  return customFetch('Module', {
    body: JSON.stringify(Module),
    headers: { 'Content-Type': 'application/json' },
    method: "POST",
  })
    .then((response) => response.json() as Promise<ApiResponse<string>>);
};

export const updateModule = (module: ModuleViewModel): Promise<Response> => {
  return customFetch('Module', {
    body: JSON.stringify(module),
    headers: { 'Content-Type': 'application/json' },
    method: "PUT",
  });
};

export const publishModule = (module: ModuleViewModel): Promise<Response> => {
  return customFetch(`Module/status/${module.id}/${ModuleStatus.Published}`, {
    body: JSON.stringify(module),
    headers: { 'Content-Type': 'application/json' },
    method: "PUT",
  });
};

export const archiveModule = (module: ModuleViewModel): Promise<Response> => {
  return customFetch(`Module/status/${module.id}/${ModuleStatus.Archived}`, {
    body: JSON.stringify(module),
    headers: { 'Content-Type': 'application/json' },
    method: "PUT",
  });
}

export const deleteModule = (moduleId: string): Promise<Response> => {
  return customFetch(`Module/${moduleId}`, {
    headers: { 'Content-Type': 'application/json' },
    method: "DELETE",
  });
}
